import { Box, IconButton, Skeleton, Tooltip, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import ImageView from "../../assets/img/taskView.png";
import { useDispatch, useSelector } from "react-redux";
import { setGlobalLoading, setPageTitle } from "../../reduxStore/SettingsReducer";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import MessageIcon from "@mui/icons-material/Message";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import leadershipImage from "../../assets/img/leadership.png";
import companyImage from "../../assets/img/business-and-trade.png";
import TaskImage from "../../assets/img/clipboard.png";
import user1Image from "../../assets/img/user (1).png";
import groupImages from "../../assets/img/group.png";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import FormatAlignRightIcon from "@mui/icons-material/FormatAlignRight";
import FormatAlignLeftIcon from "@mui/icons-material/FormatAlignLeft";
import EditIcon from "@mui/icons-material/Edit";
import GroupsIcon from "@mui/icons-material/Groups";
import AttachmentIcon from "@mui/icons-material/Attachment";
import * as RiIcons from "react-icons/ri";
import * as AiIcons from "react-icons/ai";
import * as ImIcons from "react-icons/im";

import { Button } from "evergreen-ui";
import Details from "../Tasks/Details";
import AccessAlarmIcon from "@mui/icons-material/AccessAlarm";
import AssingUser from "../Tasks/AssignUser";
import ShowFile from "../Tasks/ShowFile";
import PersonIcon from "@mui/icons-material/Person";
import Comments from "../Tasks/Comments";
import AttachFile from "../Tasks/AttachFile";
import Status from "../Tasks/Status";
import moment from "moment";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import CommentIcon from "@mui/icons-material/Comment";
import { toast } from "react-toastify";
import Cookies from "universal-cookie";
import Host from "../../assets/js/Host";
import feHost from "../../assets/js/feHost";
import Lottie from "lottie-react-web";
import APP_CONSTANTS from "../../assets/js/constants";
import WorkLogs from "../Tasks/WorkLog";
import helpers from "../../assets/js/helper";
import ViewAllUnits from "./ViewAllUnits";
import Preloading from "../Preload/Preloading";
import AssignUser from "../Tasks/AssignUser";
import GroupIcon from "@mui/icons-material/Group";
import EditCustomer from "./EditCustomer";
import { subDays, addDays } from "date-fns";
import AddIcon from "@mui/icons-material/Add";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import CInstallationFromCCDialog from "../Tasks/TasksTable/Components/CInstallationFromCCDialog";
import CreateCustomer from "../Tasks/TasksTable/Components/CreateCustomer";
import CCustomerCareDialog from "../Tasks/TasksTable/Components/CCustomerCareDialog";
import UCustomerCareDialog from "../Tasks/TasksTable/Components/UCustomerCareDialog";
import CreateMissionDialog from "../Planning/Components/CreateMissionDialog";
import host from "../../assets/js/Host";
import ShowMissions from "./ShowMissions";
import ScaleIcon from "@mui/icons-material/Scale";
import ShowFilev2 from "../Tasks/ShowFilev2";
import CreateNewFolderIcon from "@mui/icons-material/CreateNewFolder";
import DeleteIcon from "@mui/icons-material/Delete";
import LogForm from "../Tasks/LogForm";
import axios from "../../assets/js/AxiosInterceptors";
import DetailsList from "../Finances/components/DetailsList";
import FinancesList from "../Finances/components/FinancesList";
import VehiclesList from "../Finances/components/VehiclesList";
import VehiclesList2 from "../UnitsTransfer/components/VehiclesList";
import { TbTransfer } from "react-icons/tb";
import FileSaver from "file-saver";
import * as XLSX from "xlsx";
import AddForm from "../Finances/AddForm";
import AddForm2 from "../UnitsTransfer/AddForm";

const cookies = new Cookies();
var spin;

export default function NewTicketViewCustomer({ skeletonLoading, setSkeletonLoading, ...props }) {
  const dispatch = useDispatch();
  const screenwidth = useSelector(state => state.settingsData.screenwidth);
  const [commentOrWorkLog, setCommentOrWorkLog] = useState(false);
  const [isRtl, setIsRtl] = useState(true);
  const [expanded, setExpanded] = React.useState("panel1");
  const [isShown, setIsShown] = React.useState(false);
  const [showAssing, setShowAssing] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [showAttachFile, setShowAttachFile] = useState(false);
  const [allMissionsForTask, setAllMissionsForTask] = useState([]);
  const [showPromot, setShowPromot] = React.useState(false);
  const [showFiles, setShowFiles] = useState(false);
  const [showLogForm, setShowLogForm] = useState(false);
  const isopensidemenu = useSelector(state => state.settingsData.isopensidemenu);
  //this states for make installation task
  const [open, setOpen] = useState(false);
  const [selectedInstallationFields, setSelectedInstallationFields] = useState(null);
  const [governoratesSelected, setGovernoratesSelected] = useState([]);
  const [governorates, setgovernorates] = useState([]);
  const [workTypesSelected, setWorkTypesSelected] = useState([]);
  const [workTypes, setworkTypes] = useState([]);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [openCreateInstallationDialog, setOpenCreateInstallationDialog] = useState(false);
  const [openCreateDialog, setOpenCreateDialog] = useState(false);
  const [addDaysToFixDateOffset, setAddDaysToFixDateOffset] = useState(0);
  const [openCCustomerDialog, setOpenCCustomerDialog] = useState(false);
  const [editCustomer, setEditCustomer] = useState(null);
  const [openTelegramDialog, setOpenTelegramDialog] = useState(false);
  const [sendTaskTelegram, setSendTaskTelegram] = useState({});
  const [editTaskId, setEditTaskId] = useState(false);
  const [selectReqestTypes, setSelectReqestTypes] = useState([]);
  const [requestTypes, setRequestTypes] = useState([]);
  const [selectedCustomerCareFields, setSelectedCustomerCareFields] = useState(null);
  const [customers, setcustomers] = useState([]);
  const [customerID, setcustomerID] = useState(null);
  const [taskTypesSelected, setTaskTypesSelected] = useState([]);
  const [inUpdateProcess, setInUpdateProcess] = useState(false);
  const [selectedDateRange, SetSelectedDateRange] = useState([
    {
      startDate: moment
        .utc(subDays(new Date(), 1))
        .startOf("day")
        .toDate(),
      endDate: moment
        .utc(subDays(new Date(), 1))
        .endOf("day")
        .toDate(),
      key: "selection"
    }
  ]);
  const [users, setUsers] = useState([]);
  // function to get the date range changed value
  function dateChange(item) {
    setAddDaysToFixDateOffset(1);
    if (item && item?.selection) SetSelectedDateRange([item.selection]);
    else if (item && item?.range1) SetSelectedDateRange([item.range1]);
  }
  const [usersCreatedbySelected, setUsersCreatedbySelected] = useState([]);
  const [usersAssignedToSelected, setUsersAssignedToSelected] = useState([]);
  const [editTaskData, seteditTaskData] = useState({
    monitorSelected: [],
    assignedUsersSelected: [],
    governoratesSelected: [],
    geoFenceSelected: [],
    workTypesSelected: [],
    weightSelected: "0",
    deadlineDateSelected: new Date(),
    description: "",
    geofenceName: "",
    governorateSelected: [],
    numberOfUnits: "0",
    contactedNumber: "0",
    contactedPerson: "",
    customerId: null,
    selectedStatusKeys: []
  });
  const [taskStatuses, setTaskStatuses] = useState([
    {
      status_name: "",
      status_id: 0
    }
  ]);
  const [taskStatusesSelected, setTaskStatusesSelected] = useState([]);
  const [taskTypes, setTaskTypes] = useState([
    {
      name: "",
      task_type_id: 0
    }
  ]);
  const [assigners, setAssigners] = useState([
    {
      name: "",
      user_id: 0
    }
  ]);
  const [monitors, setMonitors] = useState([
    {
      name: "",
      user_id: 0
    }
  ]);
  // variable to hold external users
  const [externalUsers, setExternalUsers] = useState([
    {
      name: "",
      user_id: 0
    }
  ]);
  // variable to hold internal users
  const [internalUsers, setInternalUsers] = useState([
    {
      name: "",
      user_id: 0
    }
  ]);
  const [subTaskData, setSubTaskData] = useState({});
  const [loadingData, setLoadingData] = useState(false);
  const [showAllMissions, setShowAllMissions] = useState(false);
  //create mission states ....
  const [openCreatMission, setOpenCreateMission] = React.useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [editTaskDataMission, setEditTaskDataMission] = useState({});
  const [availableResources, setAvailableResources] = useState([]);
  const [customersUnits, setCustomersUnits] = useState([]);
  const [customersUnitsList, setCustomersUnitsList] = useState([]);
  const [executionTime, setExecutionTime] = useState(moment().day() == 4 ? moment().add(2, "days") : moment().add(1, "days"));
  const [firstOpen, setFirstOpen] = useState(false);
  const [missionData, setMissionData] = useState({
    missionTypeSelectedItemKeys: [],
    executionTime: new Date(),
    durationHours: 0,
    durationMinutes: 15,
    instructionValue: "",
    task_id: 0
  });
  const updateTable = () => {};
  const [missionTypes, setMissionTypes] = useState([
    {
      name: "",
      id: 0
    }
  ]);
  const [loadingVehiclesList, setLoadingVehiclesList] = useState(false);
  const [vehicles, setVehicles] = useState([]);

  const getEditTaskDataFromAPI = async (selectedTaskId, createInstallation) => {
    const cookies = new Cookies();
    const headers = { jwt: cookies.get("token") };

    let hostPath = Host + (props?.externalTasks_v2 == 1 ? `tasks/external_customer_care/${selectedTaskId}` : `tasks/customer_care/${selectedTaskId}`);

    setOpen(true);
    let res = await axios({
      url: hostPath,
      method: "GET",
      headers: headers
    })
      .then(response => {
        //console.log("inside get data")
        if (response.data.status === false) {
          cookies.remove("token");
          window.location.href = "/";
        } else {
          //console.log(response.data.data ? response.data.data[0] : {})

          try {
            seteditTaskData({
              task_id: selectedTaskId,
              monitorSelected: response?.data?.data[0]?.monitors_ids ? response.data.data[0]?.monitors_ids && response.data.data[0]?.monitors_ids.split(",").map(id => parseInt(id, 10)) : props?.taskData?.monitor && props?.taskData?.monitor?.length ? props?.taskData?.monitor?.map(itm => itm?.id) : [],
              assignedUsersSelected: response.data.data[0]?.to_ids ? response.data.data[0]?.to_ids.split(",").map(id => parseInt(id, 10)) : props?.taskData?.assigners && props?.taskData?.assigners?.length ? props?.taskData?.assigners?.map(itm => itm?.user_id) : [],
              workTypesSelected: [],
              weightSelected: response.data.data[0]?.weight ? response.data.data[0]?.weight : props?.taskData?.weight ? props?.taskData?.weight : 0,
              deadlineDateSelected: response.data.data[0]?.dead_time,
              description: response.data.data[0]?.description ? response.data.data[0]?.description : props?.taskData?.description ? props?.taskData?.description : "",
              taskId: selectedTaskId,
              numberOfUnits: response.data.data[0]?.num_of_units ? response.data.data[0]?.num_of_units : props?.taskData?.num_of_units ? props?.taskData?.num_of_units : 0,
              contactedNumber: response.data.data[0]?.contacted_num,
              contactedPerson: response.data.data[0]?.contacted_person,
              customerId: response.data.data[0]?.customer_id,
              status: response.data.data[0]?.status,
              governorateSelected: response.data.data[0]?.governorate_id ? response.data.data[0]?.governorate_id : props?.taskData?.governorate_id ? props?.taskData?.governorate_id : [],
              geofenceName: response.data.data[0]?.Geofence ? response.data.data[0]?.Geofence : props?.taskData?.geofences?.geo_name ? props?.taskData?.geofences?.geo_name : "",
              geoFenceSelected: props?.taskData?.geofences && props?.taskData?.geofences?.geo_name ? props?.taskData?.geofences : []
            });
            setcustomerID(response.data.data[0]?.customer_id);
            setInUpdateProcess(true);

            localStorage.setItem(
              "editTaskData",
              JSON.stringify({
                task_id: selectedTaskId,
                monitorSelected: response.data.data[0]?.monitors_ids ? response?.data?.data[0]?.monitors_ids && response?.data?.data[0]?.monitors_ids.split(",").map(id => parseInt(id, 10)) : [0],
                assignedUsersSelected: response?.data?.data[0]?.to_ids ? response.data.data[0]?.to_ids.split(",").map(id => parseInt(id, 10)) : [],
                workTypesSelected: [],
                weightSelected: response.data.data[0]?.weight ? response.data.data[0]?.weight : 0,
                deadlineDateSelected: response.data.data[0]?.dead_time,
                description: response.data.data[0]?.description,
                taskId: selectedTaskId,
                numberOfUnits: response.data.data[0]?.num_of_units ? response.data.data[0]?.num_of_units : 0,
                contactedNumber: response.data.data[0]?.contacted_num,
                contactedPerson: response.data.data[0]?.contacted_person,
                customerId: response.data.data[0]?.customer_id,
                status: response.data.data[0]?.status,
                governorateSelected: response.data.data[0]?.governorate_id ? response.data.data[0]?.governorate_id : props?.taskData?.governorate_id ? props?.taskData?.governorate_id : [],
                geofenceName: response.data.data[0]?.Geofence ? response.data.data[0]?.Geofence : "",
                geoFenceSelected: []
              })
            );

            setOpen(false);
            setEditTaskId(selectedTaskId);
            if (createInstallation) {
              setOpenCreateInstallationDialog(true);
            } else {
              setOpenEditDialog(true);
            }
          } catch (error) {
            toast.error("error:" + error);
          }
        }
      })
      .catch(err => {});
  };
  var headers = {
    jwt: cookies.get("token")
  };
  async function populateDropDownLists() {
    /// fetch task statuses from the api
    try {
      setLoadingData(true);
      const statusesResult = await axios({
        url: Host + `tasks/statuses`,
        method: "GET",
        headers: headers
      });
      setTaskStatuses(statusesResult.data.data);
      //console.log(res.data.data);
      //console.log("taskstatuses")
      if (
        statusesResult.data.data.filter(function(e) {
          return e.status_id === APP_CONSTANTS.newType_id.status_id;
        }).length > 0 &&
        statusesResult.data.data.filter(function(e) {
          return e.status_id === APP_CONSTANTS.inprogressType_id.status_id;
        }).length > 0
      ) {
        setTaskStatusesSelected([APP_CONSTANTS.newType_id, APP_CONSTANTS.inprogressType_id]);
        //console.log("insid ==")
      }
      const usersResult = await axios({
        url: Host + `users/userslist`,
        method: "GET",
        headers: headers,
        params: {
          enabled: 1
        }
      });
      setUsers(usersResult.data.data);
      const monitors = usersResult.data.data.filter(user => user.department_id != APP_CONSTANTS.TECHNICIANS_DEPARTMENT_ID);
      setMonitors(monitors);
      const assigners = usersResult.data.data.filter(user => user.department_id != APP_CONSTANTS.TECHNICIANS_DEPARTMENT_ID);
      setAssigners(assigners);

      /// fetch task types from the api
      const taskTypesResult = await axios({
        url: Host + `task_types`,
        method: "GET",
        headers: headers
      });
      setTaskTypes(taskTypesResult.data.data);
      /// fetch Internal techs users from the api
      const internalUsersResult = await axios({
        url: Host + `users/userslist?department_id=${APP_CONSTANTS.TECHNICIANS_DEPARTMENT_ID}`,
        method: "GET",
        headers: headers,
        params: {
          enabled: 1
        }
      });
      setInternalUsers(internalUsersResult.data.data);

      /// fetch External techs users from the api
      const externalUsersResult = await axios({
        url: Host + `users/userslist?department_id=${APP_CONSTANTS.ENGINEERS_DEPARTMENT_ID}`,
        method: "GET",
        headers: headers,
        params: {
          enabled: 1
        }
      });
      setExternalUsers(externalUsersResult.data.data);

      /// installation task related data
      /// fetch governorates from the api
      const governoratesResult = await axios({
        url: Host + `governorates`,
        method: "GET",
        headers: headers
      });
      //console.log("from api governorates");
      //console.log(governoratesResult.data.data);
      setgovernorates(governoratesResult.data.data);

      /// fetch governorates from the api
      const workTypes = await axios({
        url: Host + `work_types`,
        method: "GET",
        headers: headers
      });
      console.log(workTypes.data.data);
      setworkTypes(workTypes.data.data);

      axios({
        url: Host + `planning/mission_types`,
        method: "GET",
        headers: headers
      })
        .then(res => {
          setMissionTypes(res.data.data.data);
        })
        .catch(err => {});
      axios({
        url: Host + `car_inspection/cars/list`,
        method: "GET",
        headers: headers
      })
        .then(res => {
          setVehicles(res?.data?.data?.data);
        })
        .catch(err => {});
      setLoadingData(false);
    } catch (error) {
      toast.error("Error: " + error);
      setLoadingData(false);
    }
  }
  const getSubTaskData = async id => {
    axios({
      url: Host + `tasks/task/${id}?params={"from_date":0,"to_date":0}`,
      method: "GET",
      headers: headers
    }).then(res => {
      console.log("this is noti data", res.data.data);
      setSubTaskData(res.data.data[0]);
    });
  };
  useEffect(() => {
    populateDropDownLists();
  }, []);

  useEffect(() => {
    if (props?.SubTaskId) {
      getSubTaskData(props?.SubTaskId);
    }
  }, [props?.SubTaskId]);

  const getStatusColor = status => {
    switch (status) {
      case "approved":
        return "#188718b5";
      case "rejected":
        return "#da251e";
      case "closed":
        return "gray";
      case "new":
        return "#2e6b95";
      case "in progress":
        return "#f06105cc";
      case "assigned":
        return "#d5ad00d4";
      case "archived":
        return "black";
      default:
        return "lightgrey";
    }
  };
  const getStatusColorRgba = (status, number) => {
    switch (status) {
      case "approved":
        return `rgba(24, 135, 24,${number})`;
      case "rejected":
        return `rgba(218, 37, 30,${number})`;
      case "closed":
        return `rgba(128, 128, 128, ${number})`;
      case "new":
        return `rgba(46, 107, 149, ${number})`;
      case "in progress":
        return `rgba(240, 97, 5, ${number})`;
      case "assigned":
        return `rgba(213, 173, 0, ${number}) `;
      case "archived":
        return `rgba(0, 0, 0, ${number})`;
      default:
        return `rgba(211, 211, 211, ${number})`;
    }
  };

  const handleChange = panel => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : true);
  };

  function Delete(data) {
    spin = true;
    var headers = {
      "Content-Type": "application/json",
      jwt: cookies.get("token")
    };

    axios({
      url: Host + `tasks/task/${data}`,
      method: "DELETE",
      headers: headers
    })
      .then(response => {
        if (response.data.status === false) {
          toast.error(response.data.data.text);
          spin = false;
        } else if (response.data.status === true) {
          const { onRefTask } = props;
          onRefTask();
          toast.success("deleted successfully");
          spin = false;
        }
      })
      .catch(err => {
        toast.error("Network Error");
        spin = false;
      });
  }

  const getExtraDescription = props => {
    var extraDescription = "";
    if (props.task_type_id == APP_CONSTANTS.INSTALLATION_TYPE) {
      extraDescription = "عدد الوحدات : " + props.num_of_units + "\n";
      extraDescription += "المحافظة : " + props.governorate_name + "\n";
      extraDescription += "نوع العمل : " + props.work_type_name + "\n";
      extraDescription += "اسم المخول : " + props?.contacted_person + "\n";
      extraDescription += "رقم المخول : " + props?.contacted_num + "\n";
      extraDescription += "رقم الزبون : " + (props?.customer?.phone ? props?.customer?.phone : props?.customer_phone ? props?.customer_phone : "لا يوجد") + "\n";
    } else if (props.task_type_id == APP_CONSTANTS.CUSTOMER_CARE_TYPE) {
      extraDescription = "اسم المخول : " + props.contacted_person + "\n";
      extraDescription += "رقم المخول : " + props.contacted_num + "\n";
      extraDescription += "رقم الزبون : " + (props.customer?.phone ? props?.customer?.phone : " لا يوجد") + "\n";
    }

    return extraDescription;
  };

  const closeShowAllUnits = () => {
    setIsShown(false);
  };

  React.useEffect(() => {
    console.log("sadasdasdasdas", props?.task_type_id);
  }, [props.task_type_id]);

  const renderRatingValue = () => {
    let arr = [];
    if (props?.rate_score) {
      for (let i = 1; i <= 5; i++) {
        if (i <= props?.rate_score) {
          arr.push(<AiIcons.AiFillStar style={{ color: "#ffbc03", fontSize: "25px" }} />);
        } else {
          arr.push(<AiIcons.AiFillStar style={{ color: "lightgrey", fontSize: "25px" }} />);
        }
      }
    } else {
      for (let i = 0; i < 5; i++) {
        arr.push(<AiIcons.AiFillStar style={{ color: "lightgrey", fontSize: "25px" }} />);
      }
    }
    return arr;
  };

  const handleGetDate = date => {
    if (date !== "0000-00-00") {
      return helpers.formatDate(date);
    } else return false;
  };

  const handleGetTime = (time, date) => {
    if (time !== "00:00:00" && date !== "0000-00-00") {
      return time;
    } else return false;
  };
  function openAssociatedTask(id, subId, isExternal) {
    let value = "";
    if (id && subId && isExternal) value = feHost + `Detials_TaskEdit?id=${id}&subId=${subId}&external=${isExternal}`;
    else if (id && subId) value = feHost + `Detials_TaskEdit?id=${id}&subId=${subId}`;
    else if (id) value = feHost + `Detials_TaskEdit?id=${id}`;
    window.open(value, "_blank");
  }

  useEffect(() => {
    console.log("sdasdasdvv", props?.users);
    return () => {};
  }, [props?.users]);

  const getEditTaskDataFromForMissionAPI = async selectedTaskId => {
    const cookies = new Cookies();
    const headers = { jwt: cookies.get("token") };
    setOpen(true);
    let res = await axios({
      url: Host + `tasks/task/${selectedTaskId}`,
      method: "GET",
      headers: headers
    })
      .then(response => {
        //console.log("inside get data")
        if (response.data.status === false) {
          cookies.remove("token");
          window.location.href = "/";
        } else {
          /// fetch task statuses from the api
          const searchFieldsValues = JSON.parse(localStorage.getItem("searchFiltersCreateMission"));
          axios({
            url: Host + `planning/unavailable_employees?params={"working_day":"${executionTime}"}`,
            method: "GET",
            headers: headers
          }).then(res => {
            const currentAvailableResources = res.data.data.data
              ? res.data.data.data.filter(function(e) {
                  return !e.unAvailable;
                })
              : [];

            setAvailableResources(currentAvailableResources);

            const data = response.data.data ? response.data.data[0] : {};

            setMissionData({
              missionTypeSelectedItemKeys: [],
              executionTime: new Date(),
              durationHours: 0,
              durationMinutes: 15,
              instructionValue: "",
              task_id: 0
            });

            setEditTaskDataMission({
              taskType: data ? data.task_type : "",
              monitor: data && data.monitor ? data.monitor.name : "",
              weightSelected: data ? data.weight : 0,
              deadlineDate: data.dead_time === "1970-01-01T00:00:00.000Z" ? "" : data.dead_time,
              description: data ? data.description : "",
              title: data ? data.task_title : "",
              customer: data && data.customer ? data.customer : { id: 0, name: "", phone: "" },
              numberOfUnits: data ? data.num_of_units : 0,
              contactedNumber: data ? data.contacted_num : 0,
              contactedPerson: data ? data.contacted_person : "",
              missionTypes: missionTypes ? missionTypes : [],
              instructions: data ? data.description : "",
              availableTechniciansResources: currentAvailableResources
                ? currentAvailableResources
                    .filter(item => item.department_id == APP_CONSTANTS.TECHNICIANS_DEPARTMENT_ID)
                    .map(item => {
                      return {
                        ID: item.user_id,
                        name: item.name,
                        teamLeader: 0,
                        executor: 0
                      };
                    })
                : [],
              availableEngineersResources: currentAvailableResources
                ? currentAvailableResources
                    .filter(item => item.department_id == APP_CONSTANTS.ENGINEERS_DEPARTMENT_ID)
                    .map(item => {
                      return {
                        ID: item.user_id,
                        name: item.name,
                        teamLeader: 0,
                        executor: 0
                      };
                    })
                : []
            });

            // const clearedMissionTypes=missionTypes.map((missionType)=>{
            //     return {
            //         id: missionType.id,
            //         name: missionType.name
            //     }
            // })
            console.log("missionTypes");
            console.log(missionTypes);
            console.log("clearedMissionTypes");
            // console.log(clearedMissionTypes);
            // setMissionTypes(clearedMissionTypes)
            setEditTaskId(selectedTaskId);
            setFirstOpen(true);
            setOpen(false);
            setOpenCreateMission(true);
          });
        }
      })
      .catch(err => {});
  };

  const getMissionsforTask = async () => {
    if (!props?.id) {
      console.log("task id not found!");
      return;
    }
    let data = null;
    let headers = {
      jwt: cookies.get("token"),
      "Content-Type": "application/json"
    };
    try {
      data = await axios({
        url: host + "missions/get_missions_by_task_id/" + props?.id,
        method: "get",
        headers: headers
      });
      if (data && data?.status && data?.data?.status) {
        setAllMissionsForTask(data?.data?.data.data);
      }
    } catch (err) {}
  };

  useEffect(() => {
    getMissionsforTask();
    getVehicles();
  }, [props?.id, props?.task_details]);
  useEffect(() => {
    dispatch(setPageTitle("Task Details"));
    // setSkeletonLoading(true);
    setTimeout(() => {
      // setSkeletonLoading(false);
    }, 2000);
    if (isRtl) {
      var x = document.createElement("STYLE");
      var t = document.createTextNode("p {text-align: end;}");
      x.appendChild(t);
      document.head.appendChild(x);
    } else {
      var x = document.createElement("STYLE");
      var t = document.createTextNode("p {text-align: start;}");
      x.appendChild(t);
      document.head.appendChild(x);
    }
    return () => {
      dispatch(setPageTitle(""));
    };
  }, []);

  const getCurrentStatusName = () => {
    if (props?.status == "approved") {
      return "Approved";
    } else if (props?.status == "rejected") {
      return "Rejected";
    } else if (props?.status == "closed") {
      return "Closed - " + (props?.close_status_name ? props?.close_status_name : "غير محدد");
    } else if (props?.status == "new") {
      return "new";
    } else if (props?.status == "in progress") {
      return "In progress";
    } else if (props?.status == "assigned") {
      return "Assigned";
    } else if (props?.status == "archived") {
      return "Archived";
    }
  };

  const getExtractedText = name => {
    const text = name;
    const regex = /\((.*?)\)/;
    const match = text.match(regex);

    if (match && match.length > 1) {
      const extractedText = match[1];
      return extractedText;
    } else {
      return text;
    }
  };

  useEffect(() => {
    if (!openCreateInstallationDialog) {
      props?.loadData();
    }
  }, [openCreateInstallationDialog]);

  const getVehicles = async () => {
    try {
      setLoadingData(true);
      setLoadingVehiclesList(true);
      await axios({
        url: host + "customers/get_customers_units",
        method: "GET",
        headers: headers,
        params: {
          erp_server_id: JSON.parse(props?.customer?.erp_server_id),
          erp_wailon_acc_code: JSON.parse(props?.customer?.erp_wailon_acc_code)
        }
      })
        .then(res => {
          setLoadingData(false);
          if (!res.data.status) {
            toast.error("Network Error!");
            setCustomersUnits([]);
            setLoadingVehiclesList(false);
          } else {
            const task_details = props?.task_details;

            const list = task_details?.map((task, index) => {
              const uniqueDevices = new Set(task?.vehicles?.map(v => v.device) || []);
              return {
                finance_work_type_name: task.finance_work_type_name,
                devices: Array.from(uniqueDevices).join(" || "),
                numberOfDevices: task?.vehicles?.length || 0
              };
            });

            const allVehicles = [...res?.data?.data, ...props?.task_details].reduce((acc, curr) => {
              curr?.vehicles?.forEach(vehicle => {
                if (!acc?.some(v => v?.name?.includes(vehicle?.name))) {
                  const existInApi = res?.data?.data?.find(veh => veh?.name?.includes(vehicle?.name));
                  acc.push({
                    ...existInApi,
                    details_id: curr?.id
                  });
                }
              });
              return acc;
            }, []);
            setCustomersUnitsList(allVehicles);
            setCustomersUnits(list);
            setLoadingVehiclesList(false);
          }
        })
        .catch(e => {
          setLoadingData(false);
          setLoadingVehiclesList(false);
          console.log("Error", e);
        });
    } catch (error) {
      console.log("Error", error);
      setLoadingVehiclesList(false);
    }
  };

  const downloadPdfFile = (data, name, filterData) => {
    const blob = new Blob([data], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = name ? name : "missionsReportPdf.pdf";

    document.body.appendChild(link);
    link.click();
    if (filterData?.selectedUsers && filterData?.selectedUsers?.length) {
      helpers.sendDocumentToTelegramByUserId(blob, name ? name : "missionReport.pdf", filterData?.selectedUsers);
    }
    URL.revokeObjectURL(url);
    document.body.removeChild(link);
  };

  const exportToCSV = async csvData => {
    if (csvData && csvData.length > 0) {
      try {
        await axios({
          url: Host + `tasks/finance_detail_download/` + props?.id,
          headers: headers,
          method: "GET"
        }).then(response => {
          if (response && response.data && response.data.data && response.data.data.success) {
            let fileName = response.data.data.name;
            let res = axios({
              url: Host + `missions/download?params={"fileName":"${fileName}","is_pdf":"${0}"}`,
              method: "GET",
              headers: headers,
              responseType: "blob"
            })
              .then(response => {
                const originalDate = new Date();
                originalDate.setDate(originalDate.getDate());
                const formattedDate = originalDate.toISOString().split("T")[0];
                let url = window.URL.createObjectURL(new Blob([response.data]));
                let link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", `#${props?.id}Finance_task_units.xlsx`);
                document.body.appendChild(link);
                link.click();
              })
              .catch(err => {
                setOpen(false);
                console.log("Error: ", err);
              });
          } else {
            setOpen(false);
            dispatch(setGlobalLoading(false));
          }
        });
      } catch (error) {
        console.log("Error: ", error);
      }
    }
  };

  const handleExportData = () => {
    let arr = [];
    try {
      const sampleVehicleID = props?.task_details?.find(detail => detail?.vehicles?.length > 0)?.vehicles[0]?.vehicle_id;
      const account = customersUnitsList?.find(unit => unit?.id === sampleVehicleID)?.account;
      const account_id = customersUnitsList?.find(unit => unit?.id === sampleVehicleID)?.account_id;
      props?.task_details?.map(detail => {
        if (detail?.finance_work_type_id === 1 || detail?.finance_work_type_id === 2) {
          detail?.vehicles?.map(vehicle => {
            customersUnitsList?.find(itm => {
              if (itm.id === vehicle?.vehicle_id) {
                arr.push({
                  Customer: itm?.account,
                  "Account ID": itm?.account_id,
                  "Unit Number": itm?.name,
                  Device: itm?.device,
                  IMEI: itm?.imei,
                  device_status: detail?.device_status_name,
                  worktype: detail?.finance_work_type_name
                });
              }
            });
          });
        } else {
          arr.push({
            Customer: account,
            "Account ID": account_id,
            "Unit Number": detail?.vehicle_number,
            Device: "-",
            IMEI: "-",
            device_status: "-",
            worktype: detail?.finance_work_type_name
          });
        }
      });
      exportToCSV(arr);
    } catch (err) {
      console.log(err?.message);
    }
  };

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        position: "relative",
        marginTop: "53px",
        transition: "all 0.4s ease-in-out",
        display: "flex",
        alignItems: "flex-start",
        flexWrap: "wrap"
      }}
    >
      {/*==============================================
       ===============Other PoPup here====================
       ============================================== */}
      {showPromot ? (
        <div
          style={{
            position: "fixed",
            top: "0",
            left: "0",
            right: "0",
            bottom: "0",
            zIndex: 44444,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backdropFilter: "blur(10px)"
          }}
        >
          <div
            style={{
              backgroundColor: "#fff",
              boxShadow: "0 0 7px -2px rgba(0,0,0,0.2)",
              width: "600px",
              height: "300px",
              borderRadius: "5px",
              padding: "20px 20px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              animationName: "popupAnimationinViewTaskDetails",
              animationDuration: "0.5s",
              animationTimingFunction: " ease-in-out",
              animationFillMode: "both"
            }}
          >
            <p style={{ fontSize: "18px" }}>This Task Is Associated with an External Task With status "{subTaskData?.status}". Do you want to open it?</p>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center"
              }}
            >
              <button
                style={{
                  width: "100px",
                  height: "40px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: "16px",
                  backgroundColor: "#e7bb2c",
                  border: "none",
                  outline: "none",
                  borderRadius: "5px",
                  boxShadow: "0 0 -7px 2px rgba(0,0,0,0.4)",
                  color: "#fff",
                  marginRight: "10px"
                }}
                onClick={() => {
                  setShowPromot(false);
                }}
              >
                close
              </button>
              <button
                style={{
                  width: "100px",
                  height: "40px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: "16px",
                  backgroundColor: "#0e3750",
                  border: "none",
                  outline: "none",
                  borderRadius: "5px",
                  boxShadow: "0 0 -7px 2px rgba(0,0,0,0.4)",
                  color: "#fff"
                }}
                onClick={() => {
                  openAssociatedTask(props?.SubTaskId, props?.TaskId, props?.externalTasks);
                }}
              >
                open
              </button>
            </div>
          </div>
        </div>
      ) : null}
      {showAllMissions ? <ShowMissions isShown={showAllMissions} closeShowAllUnits={() => setShowAllMissions(false)} missions={allMissionsForTask} user_name={props?.user_name} account_name={props?.account_name} created_at={props?.created_at} id={props?.id} request_type_name={props?.request_type_name} /> : null}
      {isShown ? <ViewAllUnits isShown={isShown} closeShowAllUnits={closeShowAllUnits} units={props?.units} user_name={props?.user_name} account_name={props?.account_name} created_at={props?.created_at} request_type_name={props?.request_type_name} /> : null}
      {!loadingData ? (
        <>
          {openCreateInstallationDialog ? (
            <CInstallationFromCCDialog
              data={editTaskData}
              setData={seteditTaskData}
              customerID={customerID}
              taskStatuses={taskStatuses}
              setcustomerID={setcustomerID}
              governorates={governorates}
              setgovernorates={setgovernorates}
              workTypes={workTypes}
              setworkTypes={setworkTypes}
              setOpen={setOpen}
              externalTasks={props?.externalTasks}
              open={open}
              taskTypes={taskTypes}
              editTaskId={editTaskId}
              assignedUsers={assigners}
              setAssigners={setAssigners}
              monitors={monitors}
              setMonitors={setMonitors}
              headers={headers}
              popupVisible={openCCustomerDialog}
              setpopupVisible={setOpenCCustomerDialog}
              openDialog={openCreateInstallationDialog}
              setOpenDialog={setOpenCreateInstallationDialog}
              taskData={props?.taskData}
              reload={() => {}}
            />
          ) : null}

          {openCCustomerDialog ? (
            <CreateCustomer popupVisible={openCCustomerDialog} setpopupVisible={setOpenCCustomerDialog} openDialog={openCreateDialog} setOpen={setOpen} inUpdateProcess={inUpdateProcess} setOpenEditDialog={setOpenEditDialog} setcustomerID={setcustomerID} open={open} data={editTaskData} setData={seteditTaskData} editCustomer={editCustomer} setOpenDialog={setOpenCreateDialog} />
          ) : null}
          {openCreateDialog ? (
            <CCustomerCareDialog
              selectedCustomerCareFields={selectedCustomerCareFields}
              customerID={customerID}
              setcustomerID={setcustomerID}
              setOpen={setOpen}
              open={open}
              setEditCustomer={setEditCustomer}
              monitors={monitors}
              setMonitors={setMonitors}
              assigners={assigners}
              setAssigners={setAssigners}
              headers={headers}
              customers={customers}
              popupVisible={openCCustomerDialog}
              setpopupVisible={setOpenCCustomerDialog}
              openDialog={openCreateDialog}
              setOpenDialog={setOpenCreateDialog}
              reload={() => {}}
            />
          ) : null}
          {openEditDialog ? (
            <UCustomerCareDialog
              data={editTaskData}
              setData={seteditTaskData}
              customerID={customerID}
              taskStatuses={taskStatuses}
              setcustomerID={setcustomerID}
              setOpen={setOpen}
              open={open}
              taskTypes={taskTypes}
              editTaskId={editTaskId}
              monitors={monitors}
              setMonitors={setMonitors}
              assigners={assigners}
              setAssigners={setAssigners}
              headers={headers}
              customers={customers}
              popupVisible={openCCustomerDialog}
              setpopupVisible={setOpenCCustomerDialog}
              openDialog={openEditDialog}
              setOpenDialog={setOpenEditDialog}
              reload={() => {}}
            />
          ) : null}
          {editTaskId ? (
            <CreateMissionDialog
              data={editTaskDataMission}
              setFirstOpen={setFirstOpen}
              firstOpen={firstOpen}
              setData={setEditTaskDataMission}
              setOpen={setOpen}
              setExecutionTime={setExecutionTime}
              executionTime={executionTime}
              setAvailableResources={setAvailableResources}
              availableResources={availableResources}
              open={open}
              missionData={missionData}
              setMissionData={setMissionData}
              updateTable={updateTable}
              missionTypes={missionTypes}
              setMissionTypes={setMissionTypes}
              editTaskId={editTaskId}
              monitors={users}
              openDialog={openCreatMission}
              setOpenDialog={setOpenCreateMission}
              vehicles={vehicles}
            />
          ) : null}
        </>
      ) : null}

      {[APP_CONSTANTS.INSTALLATION_TYPE, APP_CONSTANTS.CUSTOMER_CARE_TYPE].includes(props.task_type_id) ? (
        <></>
      ) : (
        <>
          {showAssing ? <AssingUser addForm={showAssing} setAddForm={setShowAssing} users={props?.users} id={props.id} onRefTask={props} assigned={props.assigned} /> : null}
          {props.status !== "new" && props.task_type === "حذف" ? null : showEdit ? (
            <>
              {props.task_type_id === 17 ? (
                <AddForm
                  addForm={showEdit}
                  setAddForm={setShowEdit}
                  object={props?.taskData}
                  setObject={() => null}
                  reload={() => null}
                  createMode={props?.taskData ? false : true}
                  editTaskData={props?.taskData}
                  onProfileDelete={props?.taskData?.onProfileDelete}
                  id={props?.taskData?.task_id}
                  title={props?.taskData?.task_title}
                  time={props?.taskData?.time}
                  desc={props?.taskData?.description}
                  moniter={props?.taskData?.moniter}
                  status={props?.taskData?.task_status}
                  task_type={props?.taskData?.task_type}
                  geofences={props?.taskData?.geofences}
                  weight={props?.taskData?.weight}
                  onRefreshGeo={props?.taskData?.onRefreshGeo}
                  monitor={props?.taskData?.monitor}
                  onRefTask={props?.taskData?.onRefTask}
                />
              ) : props.task_type_id === 18 ? (      
                <AddForm2
                  addForm={showEdit}
                  setAddForm={setShowEdit}
                  object={props?.taskData}
                  setObject={() => null}
                  reload={() => null}
                  createMode={props?.taskData ? false : true}
                  editTaskData={props?.taskData}
                  onProfileDelete={props?.taskData?.onProfileDelete}
                  id={props?.taskData?.task_id}
                  title={props?.taskData?.task_title}
                  time={props?.taskData?.time}
                  desc={props?.taskData?.description}
                  moniter={props?.taskData?.moniter}
                  status={props?.taskData?.task_status}
                  task_type={props?.taskData?.task_type}
                  geofences={props?.taskData?.geofences}
                  weight={props?.taskData?.weight}
                  onRefreshGeo={props?.taskData?.onRefreshGeo}
                  monitor={props?.taskData?.monitor}
                  onRefTask={props?.taskData?.onRefTask}
                />
              ) : (
                <EditCustomer
                  addForm={showEdit}
                  setAddForm={setShowEdit}
                  allstatus={props.allstatus}
                  onProfileDelete={props}
                  id={props.id}
                  title={props?.name}
                  time={props.time}
                  desc={props.desc}
                  status={props.status}
                  type={props.type}
                  task_type={props.task_type}
                  users={props.users}
                  Geofences={props.Geofences}
                  geofences={props.geofences}
                  weight={props.weight}
                  onRefreshGeo={props}
                  monitor={props.monitor}
                  onRefTask={props}
                  customer={props.customer}
                  Allcustomer={props.Allcustomer}
                  customersUnits={props?.taskData?.task_units_transfer}
                  erp_cus_id={props?.erp_cus_id}
                  taskData={props?.taskData}
                />
              )}
            </>
          ) : null}
        </>
      )}
      {showAttachFile ? <AttachFile addForm={showAttachFile} setAddForm={setShowAttachFile} id={props.id} onRefTask={props} /> : null}
      {showFiles ? <ShowFilev2 files={props.files} onRefTask={props} showFiles={showFiles} setShowFiles={setShowFiles} status={props.status} /> : null}
      {showLogForm ? <LogForm addForm={showLogForm} setAddForm={setShowLogForm} id={props?.id} /> : null}

      {/*==============================================
       ===============header here====================
       ============================================== */}
      <Box
        sx={{
          width: "100%",
          height: "300px",
          backgroundColor: "#f3f3f3",
          position: "relative",
          overflow: "hidden",
          borderRadius: "5px"
        }}
      >
        {skeletonLoading ? (
          <Skeleton
            animation="wave"
            sx={{
              width: "100%",
              height: "300px",
              position: "absolute",
              zIndex: "1 !important",
              webkitTransform: "scale(1) !important",
              transform: "scale(1) !important"
            }}
            height={"100%"}
            width="100%"
          />
        ) : (
          <img
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              width: "100%",
              height: "100%",
              zIndex: 1,
              objectFit: "cover",
              backgroundPosition: "center center",
              backgroundRepeat: "no-repeat"
            }}
            src={ImageView}
          />
        )}
        {!skeletonLoading ? (
          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              width: "100%",
              height: "100%",
              zIndex: 2,
              background: `linear-gradient(0deg, ${props?.status ? getStatusColorRgba(props?.status, 1) : "rgba(30,106,153,1)"} 0%, ${props?.status ? getStatusColorRgba(props?.status, 0.9192927170868347) : "rgba(30,106,153,0.9192927170868347)"} 16%, ${props?.status ? getStatusColorRgba(props?.status, 0.8688725490196079) : "rgba(30,106,153,0.8688725490196079)"} 32%, ${
                props?.status ? getStatusColorRgba(props?.status, 0.8268557422969187) : "rgba(30,106,153,0.8268557422969187)"
              } 51%, ${props?.status ? getStatusColorRgba(props?.status, 0.5859593837535014) : "rgba(30,106,153,0.4859593837535014)"} 70%, ${props?.status ? getStatusColorRgba(props?.status, 0.5943627450980392) : "rgba(30,106,153,0.4943627450980392)"} 85%, ${props?.status ? getStatusColorRgba(props?.status, 0.5271358543417367) : "rgba(30,106,153,0.3271358543417367)"} 100%)`
            }}
          ></Box>
        ) : null}

        {skeletonLoading ? (
          <Skeleton
            animation="wave"
            sx={{
              position: "absolute",
              top: "0",
              left: "300px",
              width: "150px",
              height: "100px",
              backgroundColor: "#b6c2d0",
              zIndex: "100",
              WebkitClipPath: "polygon(100% 0, 0 0, 50% 100%)",
              clipPath: "polygon(100% 0, 0 0, 50% 100%)",
              filter: "drop-shadow(0 0 7px -2px #fff)",
              display: "flex",
              justifyContent: "center",
              alignItems: "flex-start",
              paddingTop: "15px",
              webkitTransform: "scale(1) !important",
              transform: "scale(1) !important"
            }}
          />
        ) : (
          <Box
            sx={{
              position: "absolute",
              top: "0",
              left: "380px",
              width: props?.status == "closed" ? "230px" : props?.status == "in progress" ? "180px" : "150px",
              height: props?.status == "closed" ? "120px" : "100px",
              backgroundColor: props?.status ? getStatusColor(props?.status) : "#1e6a99",
              zIndex: "100",
              WebkitClipPath: "polygon(100% 0, 0 0, 50% 100%)",
              clipPath: "polygon(100% 0, 0 0, 50% 100%)",
              filter: "drop-shadow(0 0 7px -2px #fff)",
              display: "flex",
              justifyContent: "center",
              alignItems: "flex-start",
              paddingTop: "15px"
            }}
          >
            <p
              style={{
                fontSize: props?.status == "closed" ? "18px" : props?.status == "in progress" ? "20px" : "22px",
                color: "#fff"
              }}
            >
              {getCurrentStatusName()}
            </p>
          </Box>
        )}
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginTop: "50px",
            zIndex: 3,
            position: "relative",
            padding: "0 30px"
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "10px"
            }}
          >
            {skeletonLoading ? (
              <>
                <Skeleton
                  animation="wave"
                  variant="circular"
                  sx={{
                    webkitTransform: "scale(1) !important",
                    transform: "scale(1) !important"
                  }}
                  width={40}
                  height={40}
                />
                <Skeleton
                  animation="wave"
                  variant="circular"
                  sx={{
                    webkitTransform: "scale(1) !important",
                    transform: "scale(1) !important"
                  }}
                  width={40}
                  height={40}
                />
                <Skeleton
                  animation="wave"
                  variant="circular"
                  sx={{
                    webkitTransform: "scale(1) !important",
                    transform: "scale(1) !important"
                  }}
                  width={40}
                  height={40}
                />
                <Skeleton
                  animation="wave"
                  variant="rectangular"
                  sx={{
                    webkitTransform: "scale(1) !important",
                    transform: "scale(1) !important",
                    borderRadius: "20px"
                  }}
                  width={90}
                  height={40}
                />
              </>
            ) : (
              <>
                {props?.geofences?.geo_name !== "null" && props?.geofences?.geo_name !== null ? (
                  <Tooltip title={"Location-" + props?.geofences?.geo_name}>
                    <IconButton
                      sx={{
                        backgroundColor: "#fff",
                        boxShadow: "0 0 7px -2px #fff",
                        width: "40px",
                        height: "40px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        "&:hover": {
                          backgroundColor: "#fff"
                        },
                        "&:hover svg": {
                          transform: "scale(1.1)"
                        }
                      }}
                      onClick={() => {
                        if (props.geofences.geo_y < props.geofences.geo_x) {
                          window.open(`https://maps.google.com/?q=${props.geofences.geo_y},${props.geofences.geo_x}`, "_blank");
                        } else {
                          window.open(`https://maps.google.com/?q=${props.geofences.geo_x},${props.geofences.geo_y}`, "_blank");
                        }
                      }}
                    >
                      <LocationOnIcon sx={{ color: "#000" }} />
                    </IconButton>
                  </Tooltip>
                ) : null}
                {props?.files?.length > 0 ? (
                  <Tooltip title={"Attach files"}>
                    <IconButton
                      sx={{
                        backgroundColor: "#fff",
                        boxShadow: "0 0 7px -2px #fff",
                        width: "40px",
                        height: "40px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        "&:hover": {
                          backgroundColor: "#fff"
                        },
                        "&:hover svg": {
                          transform: "scale(1.1)"
                        }
                      }}
                      onClick={() => {
                        setShowFiles(true);
                      }}
                    >
                      <AttachFileIcon sx={{ color: "#000" }} />
                    </IconButton>
                  </Tooltip>
                ) : null}
                {props?.time == "1970-01-01T00:00:00.000Z" ? null : (
                  <Tooltip title={"Deadline - " + moment(props.time).format("lll")}>
                    <IconButton
                      sx={{
                        backgroundColor: "#fff",
                        boxShadow: "0 0 7px -2px #fff",
                        width: "40px",
                        height: "40px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        "&:hover": {
                          backgroundColor: "#fff"
                        },
                        "&:hover svg": {
                          transform: "scale(1.1)"
                        }
                      }}
                    >
                      <PendingActionsIcon
                        sx={{
                          color: moment().format("X") >= moment(props?.time).format("X") ? "#da251e" : "green"
                        }}
                      />
                    </IconButton>
                  </Tooltip>
                )}
                {props?.comments_count > 0 ? (
                  <Tooltip title={"Comments"}>
                    <IconButton
                      sx={{
                        backgroundColor: "#fff",
                        boxShadow: "0 0 7px -2px #fff",
                        width: "70px",
                        height: "40px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        borderRadius: "20px",
                        gap: "10px",
                        "&:hover": {
                          backgroundColor: "#fff"
                        },
                        "&:hover svg": {
                          transform: "scale(1.1)"
                        }
                      }}
                    >
                      <MessageIcon sx={{ color: "#000" }} />
                      <span style={{ fontSize: "20px", color: "#1e6a99" }}>{props?.comments_count}</span>
                    </IconButton>
                  </Tooltip>
                ) : null}
                <Tooltip title={"Weights"}>
                  <IconButton
                    sx={{
                      backgroundColor: "#fff",
                      boxShadow: "0 0 7px -2px #fff",
                      minWidth: "70px",
                      width: "fit-content",
                      height: "40px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "20px",
                      gap: "10px",
                      "&:hover": {
                        backgroundColor: "#fff"
                      },
                      "&:hover svg": {
                        transform: "scale(1.1)"
                      }
                    }}
                  >
                    <ScaleIcon sx={{ color: "#000", fontSize: "22px" }} />
                    <span style={{ fontSize: "20px", color: "#1e6a99" }}>{props?.weight}</span>
                  </IconButton>
                </Tooltip>
              </>
            )}
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-end"
            }}
          >
            {skeletonLoading ? (
              <Skeleton
                animation="wave"
                sx={{
                  webkitTransform: "scale(1) !important",
                  transform: "scale(1) !important"
                }}
                width={300}
                height={30}
              />
            ) : (
              <>
                <p style={{ fontSize: "25px", color: "#fff" }}>نوع المهمة {props.task_type}</p>
                <p
                  style={{
                    height: "2px",
                    width: "90px",
                    backgroundColor: props?.status == "in progress" || props?.status == "rejected" ? "#fff" : "#D46A43",
                    borderRadius: "5px",
                    position: "relative",
                    top: "-10px"
                  }}
                ></p>
              </>
            )}
          </Box>
        </Box>
      </Box>

      {/*==============================================
       ===============First Section here=============
       ============================================== */}
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          flexDirection: screenwidth <= 1400 ? "column" : "row",
          position: "relative",
          top: screenwidth <= 1400 ? "-105px" : "-115px",
          columnGap: "25px",
          paddingLeft: screenwidth <= 1400 ? 7 : 5,
          paddingRight: screenwidth <= 1400 ? 7 : 5
        }}
      >
        <Box
          sx={{
            flex: 1,
            display: "flex",
            justifyContent: screenwidth <= 1400 ? "center" : "flex-end",
            alignItems: "center",
            width: "100%"
          }}
        >
          {skeletonLoading ? (
            <Skeleton
              animation="wave"
              sx={{
                width: screenwidth <= 1400 ? "100%" : "95%",
                height: "fit-content",
                minHeight: "300px",
                backgroundColor: "#f2f2f2",
                boxShadow: "0 2px 7px -2px #626262  !important",
                position: "relative",
                // top: "-90px",
                zIndex: "99",
                borderRadius: "5px",
                webkitTransform: "scale(1) !important",
                transform: "scale(1) !important"
              }}
            />
          ) : (
            <Box
              sx={{
                width: screenwidth <= 1400 ? "100%" : "95%",
                height: "100%",
                minHeight: "300px",
                backgroundColor: "#fff",
                boxShadow: "0 2px 7px -2px #626262 ",
                position: "relative",
                // top: "-90px",
                zIndex: "99",
                borderRadius: "5px",
                paddingBottom: "18px"
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  padding: "15px 20px 0 20px"
                }}
              >
                {skeletonLoading ? (
                  <Skeleton
                    animation="wave"
                    sx={{
                      webkitTransform: "scale(1) !important",
                      transform: "scale(1) !important"
                    }}
                    width={300}
                    height={30}
                  />
                ) : (
                  <>
                    <p style={{ fontSize: "25px", color: "#000" }}>Task Information</p>
                    <p
                      style={{
                        height: "2.5px",
                        width: "100px",
                        backgroundColor: "#D46A43",
                        borderRadius: "5px",
                        position: "relative",
                        top: "-10px"
                      }}
                    ></p>
                  </>
                )}
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  padding: "0 20px",
                  gap: "11px"
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "19px"
                  }}
                >
                  <img
                    src={companyImage}
                    style={{
                      width: "25px",
                      height: "25px",
                      transform: "scale(1.1)",
                      backgroundPosition: "center center",
                      objectFit: "cover"
                    }}
                  />
                  <span style={{ fontFamily: "Cairo", color: "#404040" }}>{props?.customer?.name ? helpers.formatCustomerName(props?.customer?.name) : props?.name ? props?.name : props?.task_type_id === 15 ? getExtractedText(props?.contacted_person) : ""}</span>
                </Box>
                {props?.task_type_id === 18 ? (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: "19px"
                    }}
                  >
                    <TbTransfer className="iconSideMenu" style={{ width: "25px", transform: "scale(1.5)" }} />
                    <span style={{ fontFamily: "Cairo", color: "#404040" }}>{props?.taskData?.to_customer_name ? helpers.formatCustomerName(props?.taskData?.to_customer_name) : ""}</span>
                  </Box>
                ) : null}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "19px"
                  }}
                >
                  <img
                    src={TaskImage}
                    style={{
                      width: "25px",
                      height: "25px",
                      transform: "scale(1.1)",
                      backgroundPosition: "center center",
                      objectFit: "cover"
                    }}
                  />
                  <span style={{ fontFamily: "Cairo", color: "#404040" }}>#{props?.id}</span>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "19px"
                  }}
                >
                  <img
                    src={user1Image}
                    style={{
                      width: "25px",
                      height: "25px",
                      transform: "scale(1.1)",
                      backgroundPosition: "center center",
                      objectFit: "cover"
                    }}
                  />
                  <span style={{ fontFamily: "Cairo", color: "#404040" }}>{props?.createdby}</span>
                </Box>
                {props?.monitor?.name !== null ? (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: "19px"
                    }}
                  >
                    <img
                      src={leadershipImage}
                      style={{
                        width: "25px",
                        height: "25px",
                        transform: "scale(1.1)",
                        backgroundPosition: "center center",
                        objectFit: "cover"
                      }}
                    />
                    <span style={{ fontFamily: "Cairo", color: "#404040" }}>{props?.monitor?.name}</span>
                  </Box>
                ) : null}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "19px"
                  }}
                >
                  <img
                    src={groupImages}
                    style={{
                      width: "25px",
                      height: "25px",
                      transform: "scale(1.1)",
                      backgroundPosition: "center center",
                      objectFit: "cover"
                    }}
                  />
                  {props.assigners.length > 0 ? (
                    <span style={{ fontFamily: "Cairo", color: "#404040" }}>
                      {props.assigners[0].name}
                      {props.assigners.length > 1 ? (
                        <span id="OthersParent">
                          {" "}
                          + {props.assigners.length - 1} Others{" "}
                          <span id="OthersContent">
                            {" "}
                            {props.assigners.map((p, i) => (
                              <div key={i}> {p.name} </div>
                            ))}{" "}
                          </span>{" "}
                        </span>
                      ) : null}
                    </span>
                  ) : (
                    <span style={{ fontFamily: "Cairo", color: "#404040" }}>No Body</span>
                  )}
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    gap: "10px"
                  }}
                >
                  <Box
                    sx={{
                      borderRadius: "20px",
                      height: "40px",
                      width: "fit-content",
                      minWidth: "120px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      backgroundColor: "#fff",
                      boxShadow: "0 1px 7px -2px #000",
                      padding: "11px 20px",
                      gap: "10px"
                    }}
                  >
                    <CalendarMonthIcon sx={{ color: "grey", fontSize: "19px" }} />
                    <span>{moment(props.created_at).format("lll")}</span>
                  </Box>
                  <Box
                    sx={{
                      borderRadius: "20px",
                      height: "40px",
                      width: "fit-content",
                      minWidth: "120px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      backgroundColor: "#fff",
                      boxShadow: "0 1px 7px -2px #000",
                      padding: "11px 20px",
                      gap: "10px",
                      cursor: "pointer"
                    }}
                    onClick={() => {
                      if (props?.task_type_id === 15 && props?.request_type?.mandatory_units == 1) {
                        setIsShown(true);
                      }
                    }}
                  >
                    <AiIcons.AiOutlineDeploymentUnit size={19} style={{ color: "grey", fontSize: "19px" }} />
                    <span>عدد الوحدات : {props?.units?.length ? props?.units?.length : 0}</span>
                  </Box>
                </Box>
              </Box>
            </Box>
          )}
        </Box>

        <Box
          sx={{
            flex: 1,
            display: "flex",
            justifyContent: screenwidth <= 1400 ? "center" : "flex-start",
            alignItems: "center",
            width: "100%",
            marginTop: screenwidth <= 1400 ? "25px" : "0px"
          }}
        >
          {skeletonLoading ? (
            <Skeleton
              animation="wave"
              sx={{
                width: screenwidth <= 1400 ? "100%" : "95%",
                height: "fit-content",
                minHeight: "300px",
                backgroundColor: "#f2f2f2",
                boxShadow: "0 2px 7px -2px #626262  !important",
                position: "relative",
                zIndex: "99",
                // marginTop: "25px",
                borderRadius: "5px",
                webkitTransform: "scale(1) !important",
                transform: "scale(1) !important"
              }}
            />
          ) : (
            <Box
              sx={{
                width: screenwidth <= 1400 ? "100%" : "95%",
                height: "fit-content",
                minHeight: "300px",
                backgroundColor: "#fff",
                boxShadow: "0 2px 7px -2px #626262 ",
                position: "relative",
                zIndex: "99",
                borderRadius: "5px",
                paddingBottom: "20px"
              }}
            >
              <Box
                sx={{
                  position: "absolute",
                  top: 10,
                  right: 10,
                  display: "flex",
                  alignItems: "center",
                  gap: "10px"
                }}
              >
                <Tooltip title="Align Left">
                  <IconButton
                    sx={{
                      width: "35px",
                      height: "35px",
                      backgroundColor: !isRtl ? "#1e6a99" : "#fff",
                      boxShadow: "0 0 7px -2px #000",
                      "&:hover": {
                        backgroundColor: !isRtl ? "#1e6a99" : "#fff"
                      }
                    }}
                    onClick={() => {
                      setIsRtl(false);
                      var x = document.createElement("STYLE");
                      var t = document.createTextNode("p {text-align: start;}");
                      x.appendChild(t);
                      document.head.appendChild(x);
                    }}
                  >
                    <FormatAlignLeftIcon sx={{ color: !isRtl ? "#fff" : "#000" }} />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Align Right">
                  <IconButton
                    sx={{
                      width: "35px",
                      height: "35px",
                      backgroundColor: isRtl ? "#1e6a99" : "#fff",
                      boxShadow: "0 0 7px -2px #000",
                      "&:hover": {
                        backgroundColor: isRtl ? "#1e6a99" : "#fff"
                      }
                    }}
                    onClick={() => {
                      setIsRtl(true);
                      var x = document.createElement("STYLE");
                      var t = document.createTextNode("p {text-align: end;}");
                      x.appendChild(t);
                      document.head.appendChild(x);
                    }}
                  >
                    <FormatAlignRightIcon sx={{ color: isRtl ? "#fff" : "#000" }} />
                  </IconButton>
                </Tooltip>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  padding: "15px 20px 0 20px"
                }}
              >
                {skeletonLoading ? (
                  <Skeleton
                    animation="wave"
                    sx={{
                      webkitTransform: "scale(1) !important",
                      transform: "scale(1) !important"
                    }}
                    width={300}
                    height={30}
                  />
                ) : (
                  <>
                    <p style={{ fontSize: "25px", color: "#000" }}>Task Description</p>
                    <p
                      style={{
                        height: "2.5px",
                        width: "100px",
                        backgroundColor: "#D46A43",
                        borderRadius: "5px",
                        position: "relative",
                        top: "-10px"
                      }}
                    ></p>
                  </>
                )}
              </Box>
              <Box
                sx={{
                  height: "auto",
                  maxHeight: "300px",
                  overflowY: "auto",
                  padding: "0 20px",
                  "& pre": {
                    whiteSpace: "pre-wrap",
                    // wordWrap: "break-word",
                    width: "100%",
                    height: "100%"
                  }
                }}
              >
                {getExtraDescription(props)
                  .split("\n")
                  .map((i, n) => {
                    return <p key={n + "extra"}>{i}</p>;
                  })}
                <p
                  style={{
                    display: "flex",
                    direction: "rtl",
                    maxWidth: "100%",
                    flexWrap: "wrap",
                    columnGap: 3.5,
                    rowGap: 2
                  }}
                >
                  <span style={{ margin: 0, textAlign: "right" }}>{props?.desc?.replace(/\n/g, " ")}</span>
                </p>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  padding: "15px 20px 0 20px"
                }}
              >
                {skeletonLoading ? (
                  <Skeleton
                    animation="wave"
                    sx={{
                      webkitTransform: "scale(1) !important",
                      transform: "scale(1) !important"
                    }}
                    width={300}
                    height={30}
                  />
                ) : (
                  <>
                    <p style={{ fontSize: "25px", color: "#000" }}>Merged Tasks</p>
                    <p
                      style={{
                        height: "2.5px",
                        width: "100px",
                        backgroundColor: "#D46A43",
                        borderRadius: "5px",
                        position: "relative",
                        top: "-10px"
                      }}
                    ></p>
                  </>
                )}
              </Box>
              <Box
                sx={{
                  height: "auto",
                  // maxHeight: "300px",
                  overflowY: "auto",
                  padding: "0 20px",
                  "& pre": {
                    whiteSpace: "pre-wrap",
                    // wordWrap: "break-word",
                    width: "100%",
                    height: "100%"
                  }
                }}
              >
                {props?.taskData?.task_childs?.map(child => (
                  <>
                    <p style={{ fontWeight: "bold" }}>#{child?.task_id}</p>
                    {getExtraDescription(child)
                      .split("\n")
                      .map((i, n) => {
                        return <p key={n + "extra"}>{i}</p>;
                      })}
                    <p>{child?.description}</p>
                    <br />
                  </>
                ))}
              </Box>
            </Box>
          )}
        </Box>
      </Box>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          position: "relative",
          top: "-125px"
        }}
      >
        {/*==============================================
       ===============second Section here=============
       ============================================== */}
        {/*==============================================
       ===============third Section here=============
       ============================================== */}
        {props?.task_type_id === 15 ? (
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center"
            }}
          >
            {skeletonLoading ? (
              <Skeleton
                animation="wave"
                sx={{
                  width: "90%",
                  height: "fit-content",
                  minHeight: "300px",
                  backgroundColor: "#f2f2f2",
                  boxShadow: "0 2px 7px -2px #626262  !important",
                  position: "relative",
                  zIndex: "99",
                  marginTop: "25px",
                  borderRadius: "5px",
                  webkitTransform: "scale(1) !important",
                  transform: "scale(1) !important"
                }}
              />
            ) : (
              <Box
                sx={{
                  width: "90%",
                  height: "fit-content",
                  minHeight: "300px",
                  backgroundColor: "#fff",
                  boxShadow: "0 2px 7px -2px #626262 ",
                  position: "relative",
                  marginTop: "25px",
                  zIndex: "99",
                  borderRadius: "5px",
                  paddingBottom: "20px"
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    padding: "15px 20px 0 20px"
                  }}
                >
                  {skeletonLoading ? (
                    <Skeleton
                      animation="wave"
                      sx={{
                        webkitTransform: "scale(1) !important",
                        transform: "scale(1) !important"
                      }}
                      width={300}
                      height={30}
                    />
                  ) : (
                    <>
                      <p style={{ fontSize: "25px", color: "#000" }}>Customer Request and Rating</p>
                      <p
                        style={{
                          height: "2.5px",
                          width: "100px",
                          backgroundColor: "#D46A43",
                          borderRadius: "5px",
                          position: "relative",
                          top: "-10px"
                        }}
                      ></p>
                    </>
                  )}
                </Box>
                <Box
                  sx={{
                    width: "100%",
                    height: "fit-content",
                    minHeight: "200px",
                    padding: "0 20px",
                    maxHeight: "300px",
                    overflowY: "auto"
                  }}
                >
                  {props?.task_type_id === 15 ? (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "flex-end",
                        justifyContent: "center",
                        margin: "15px 0 5px 0",
                        flexDirection: "column"
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row-reverse",
                          alignItems: "center",
                          marginTop: "5px"
                        }}
                      >
                        <span style={{ fontWeight: "bold", fontSize: "16px" }}> : نوع الطلب</span>
                        <span style={{ margin: "0 5px", fontSize: "16px" }}>{props?.request_type_name}</span>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row-reverse",
                          alignItems: "center",
                          marginTop: "5px"
                        }}
                      >
                        <span style={{ fontWeight: "bold", fontSize: "16px" }}> : موقع الطلب</span>
                        <span style={{ margin: "0 5px", fontSize: "16px" }}>{props?.request_location} </span>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row-reverse",
                          alignItems: "center",
                          marginTop: "5px"
                        }}
                      >
                        <span style={{ fontWeight: "bold", fontSize: "16px" }}>: التاريخ المفضل للطلب </span>
                        <span style={{ margin: "0 5px", fontSize: "16px" }}>{handleGetDate(props?.prefered_date) ? handleGetDate(props?.prefered_date) : "لم يتم التعيين"}</span>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row-reverse",
                          alignItems: "center",
                          marginTop: "5px"
                        }}
                      >
                        <span style={{ fontWeight: "bold", fontSize: "16px" }}> : الوقت المفضل للطلب</span>
                        <span style={{ margin: "0 5px", fontSize: "16px" }}>{handleGetTime(props?.prefered_time, props?.prefered_date) ? handleGetTime(props?.prefered_time, props?.prefered_date) : "لم يتم التعيين"}</span>
                      </div>
                    </div>
                  ) : null}

                  {props?.task_type_id === 15 ? (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "flex-end",
                        justifyContent: "center",
                        margin: "0px 0",
                        flexDirection: "column"
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "flex-end",
                          margin: "15px 0"
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row-reverse",
                            alignItems: "center"
                          }}
                        >
                          {renderRatingValue()}
                        </div>
                        <span
                          style={{
                            fontFamily: "Cairo",
                            fontSize: "20px",
                            marginLeft: "15px"
                          }}
                        >
                          تقييم الزبون
                        </span>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "flex-end",
                          margin: "0 0 0 0",
                          position: "relative",
                          top: "-10px"
                        }}
                      >
                        <p
                          style={{
                            direction: "rtl",
                            textAlign: "justify",
                            wordBreak: "break-all",
                            whiteSpace: "break-spaces"
                          }}
                        >
                          {props?.rate_text}
                        </p>
                      </div>
                    </div>
                  ) : null}
                  {props?.task_type_id === 15 && props?.request_type?.mandatory_units == 1 ? (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-end",
                        margin: "15px 0"
                      }}
                    >
                      <span
                        style={{
                          fontFamily: "Cairo",
                          fontSize: "17px",
                          textDecoration: "underline",
                          cursor: "pointer"
                        }}
                        className="UnitShow"
                        onClick={() => {
                          setIsShown(true);
                        }}
                      >
                        {`عرض تفاصيل الوحدات (عدد الوحدات ${props?.units?.length})`}
                      </span>
                    </div>
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-end",
                        margin: "15px 0"
                      }}
                    >
                      <span
                        style={{
                          fontFamily: "Cairo",
                          fontSize: "17px",
                          textDecoration: "underline",
                          cursor: "pointer"
                        }}
                        className="UnitShow"
                      >
                        لم يتم اختيار مركبات
                      </span>
                    </div>
                  )}
                </Box>
              </Box>
            )}
          </Box>
        ) : null}
        {/*==============================================
       ===============fourth Section here=============
       ============================================== */}
        {props?.sub_tasks?.length > 0 || props?.main_task_id ? (
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center"
            }}
          >
            {skeletonLoading ? (
              <Skeleton
                animation="wave"
                sx={{
                  width: "90%",
                  height: "fit-content",
                  minHeight: "200px",
                  backgroundColor: "#f2f2f2",
                  boxShadow: "0 2px 7px -2px #626262  !important",
                  position: "relative",
                  zIndex: "99",
                  marginTop: "25px",
                  borderRadius: "5px",
                  webkitTransform: "scale(1) !important",
                  transform: "scale(1) !important"
                }}
              />
            ) : (
              <Box
                sx={{
                  width: "90%",
                  height: "fit-content",
                  minHeight: "200px",
                  backgroundColor: "#fff",
                  boxShadow: "0 2px 7px -2px #626262 ",
                  position: "relative",
                  marginTop: "25px",
                  zIndex: "99",
                  borderRadius: "5px",
                  paddingBottom: "20px"
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    padding: "15px 20px 0 20px"
                  }}
                >
                  {skeletonLoading ? (
                    <Skeleton
                      animation="wave"
                      sx={{
                        webkitTransform: "scale(1) !important",
                        transform: "scale(1) !important"
                      }}
                      width={300}
                      height={30}
                    />
                  ) : (
                    <>
                      <p style={{ fontSize: "25px", color: "#000" }}>Task Related</p>
                      <p
                        style={{
                          height: "2.5px",
                          width: "100px",
                          backgroundColor: "#D46A43",
                          borderRadius: "5px",
                          position: "relative",
                          top: "-10px"
                        }}
                      ></p>
                    </>
                  )}
                </Box>
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    padding: " 0 10px",
                    maxHeight: "300px",
                    overflowY: "auto"
                  }}
                >
                  {props?.sub_tasks?.map(item => (
                    <Box
                      sx={{
                        width: "100%",
                        height: "fit-content",
                        minHeight: "100px",
                        padding: " 0 20px",
                        backgroundColor: "#f3f3f3",
                        borderRadius: "10px"
                      }}
                    >
                      <Box
                        sx={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          paddingTop: "10px"
                        }}
                      >
                        <span>Task Associated with Installation Task</span>
                        <span
                          style={{
                            color: "blue",
                            textDecoration: "underline",
                            cursor: "pointer",
                            marginLeft: "10px",
                            backgroundColor: "#fff",
                            borderRadius: "20px",
                            padding: "10px 20px",
                            backgroundColor: "#fff",
                            padding: "5px 10px",
                            boxShadow: "0 0 7px -2px #000"
                          }}
                          onClick={() => openAssociatedTask(item?.task_id, props?.TaskId, props?.externalTasks)}
                        >{`#${item?.task_id}`}</span>
                      </Box>
                      <Box
                        sx={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          paddingTop: "10px"
                        }}
                      >
                        <span style={{ marginTop: "12px" }}>Task Associated Status is</span>
                        <div
                          style={{
                            width: "60%",
                            border: "1px dot #f3f3f3"
                          }}
                        ></div>
                        <span
                          style={{
                            color: getStatusColor(item?.status),
                            backgroundColor: "#fff",
                            borderRadius: "5px",
                            padding: "1px 10px",
                            cursor: "pointer",
                            marginLeft: "2px",
                            borderRadius: "20px",
                            padding: "10px 20px",
                            backgroundColor: "#fff",
                            padding: "5px 10px",
                            boxShadow: "0 0 7px -2px #000",
                            minWidth: "75px",
                            textAlign: "center"
                          }}
                          onClick={() => openAssociatedTask(item?.task_id, props?.TaskId, props?.externalTasks)}
                        >
                          {item?.status}
                        </span>
                      </Box>
                    </Box>
                  ))}
                </Box>
              </Box>
            )}
          </Box>
        ) : props?.SubTaskId ? (
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center"
            }}
          >
            {skeletonLoading ? (
              <Skeleton
                animation="wave"
                sx={{
                  width: "90%",
                  height: "fit-content",
                  minHeight: "200px",
                  backgroundColor: "#f2f2f2",
                  boxShadow: "0 2px 7px -2px #626262  !important",
                  position: "relative",
                  zIndex: "99",
                  marginTop: "25px",
                  borderRadius: "5px",
                  webkitTransform: "scale(1) !important",
                  transform: "scale(1) !important"
                }}
              />
            ) : (
              <Box
                sx={{
                  width: "90%",
                  height: "fit-content",
                  minHeight: "200px",
                  backgroundColor: "#fff",
                  boxShadow: "0 2px 7px -2px #626262 ",
                  position: "relative",
                  marginTop: "25px",
                  zIndex: "99",
                  borderRadius: "5px",
                  paddingBottom: "20px"
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    padding: "15px 20px 0 20px"
                  }}
                >
                  {skeletonLoading ? (
                    <Skeleton
                      animation="wave"
                      sx={{
                        webkitTransform: "scale(1) !important",
                        transform: "scale(1) !important"
                      }}
                      width={300}
                      height={30}
                    />
                  ) : (
                    <>
                      <p style={{ fontSize: "25px", color: "#000" }}>Task Related</p>
                      <p
                        style={{
                          height: "2.5px",
                          width: "100px",
                          backgroundColor: "#D46A43",
                          borderRadius: "5px",
                          position: "relative",
                          top: "-10px"
                        }}
                      ></p>
                    </>
                  )}
                </Box>
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    padding: " 0 10px",
                    maxHeight: "300px",
                    overflowY: "auto"
                  }}
                >
                  <Box
                    sx={{
                      width: "100%",
                      height: "fit-content",
                      minHeight: "100px",
                      padding: " 0 20px",
                      backgroundColor: "#f3f3f3",
                      borderRadius: "10px"
                    }}
                  >
                    <Box
                      sx={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        paddingTop: "10px"
                      }}
                    >
                      <span>Task Associated with Installation Task</span>
                      <span
                        style={{
                          color: "blue",
                          textDecoration: "underline",
                          cursor: "pointer",
                          marginLeft: "10px",
                          backgroundColor: "#fff",
                          borderRadius: "20px",
                          padding: "10px 20px",
                          backgroundColor: "#fff",
                          padding: "5px 10px",
                          boxShadow: "0 0 7px -2px #000"
                        }}
                        onClick={() => openAssociatedTask(props?.SubTaskId, props?.TaskId, props?.externalTasks)}
                      >{`#${props?.SubTaskId}`}</span>
                    </Box>
                    <Box
                      sx={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        paddingTop: "10px"
                      }}
                    >
                      {subTaskData && subTaskData?.status ? (
                        <>
                          <span style={{ marginTop: "12px" }}>Task Associated Status is</span>
                          <div
                            style={{
                              width: "60%",
                              border: "1px dot #f3f3f3"
                            }}
                          ></div>
                          <span
                            style={{
                              color: getStatusColor(subTaskData?.status),
                              backgroundColor: "#fff",
                              borderRadius: "5px",
                              padding: "1px 10px",
                              cursor: "pointer",
                              marginLeft: "2px",
                              borderRadius: "20px",
                              padding: "10px 20px",
                              backgroundColor: "#fff",
                              padding: "5px 10px",
                              boxShadow: "0 0 7px -2px #000",
                              minWidth: "75px",
                              textAlign: "center"
                            }}
                            onClick={() => openAssociatedTask(props?.SubTaskId, props?.TaskId, props?.externalTasks)}
                          >
                            {subTaskData?.status}
                          </span>
                        </>
                      ) : null}
                    </Box>
                  </Box>
                </Box>
              </Box>
            )}
          </Box>
        ) : null}
        {/*==============================================
       ===============fifth Section here=============
       ============================================== */}
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          }}
        >
          {skeletonLoading ? (
            <Skeleton
              animation="wave"
              sx={{
                width: "90%",
                height: "fit-content",
                minHeight: "200px",
                backgroundColor: "#f2f2f2",
                boxShadow: "0 2px 7px -2px #626262  !important",
                position: "relative",
                zIndex: "99",
                marginTop: "25px",
                borderRadius: "5px",
                webkitTransform: "scale(1) !important",
                transform: "scale(1) !important"
              }}
            />
          ) : (
            <Box
              sx={{
                width: "90%",
                height: "fit-content",
                minHeight: "200px",
                backgroundColor: "#fff",
                boxShadow: "0 2px 7px -2px #626262 ",
                position: "relative",
                marginTop: "25px",
                zIndex: "99",
                borderRadius: "5px"
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  padding: "15px 20px 0 20px"
                }}
              >
                {skeletonLoading ? (
                  <Skeleton
                    animation="wave"
                    sx={{
                      webkitTransform: "scale(1) !important",
                      transform: "scale(1) !important"
                    }}
                    width={300}
                    height={30}
                  />
                ) : (
                  <>
                    <p style={{ fontSize: "25px", color: "#000" }}>Task Operation</p>
                    <p
                      style={{
                        height: "2.5px",
                        width: "100px",
                        backgroundColor: "#D46A43",
                        borderRadius: "5px",
                        position: "relative",
                        top: "-10px"
                      }}
                    ></p>
                  </>
                )}
              </Box>
              <Box
                sx={{
                  width: "100%",
                  padding: "30px 20px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center"
                }}
              >
                <Box
                  sx={{
                    "& .MuiFab-root": {
                      backgroundColor: "#fff"
                    },
                    "& .MuiFab-root:hover": {
                      backgroundColor: "#fff"
                    }
                  }}
                >
                  <Status status={props.status} onRefTask={props} id={props.id} SubTaskId={props?.SubTaskId} externalTasks={props?.externalTasks} TaskId={props?.TaskId} setShowPromot={setShowPromot} showPromot={showPromot} subTaskData={subTaskData} taskTypeId={props?.task_type_id} getSubTaskData={getSubTaskData} iconColor="#1e6a99" erp_cus_id={props?.erp_cus_id} allowChangeStatus={false} />
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    flexDirection: "row-reverse"
                  }}
                >
                  {[APP_CONSTANTS.INSTALLATION_TYPE, APP_CONSTANTS.CUSTOMER_CARE_TYPE].includes(props?.task_type_id) ? (
                    <></>
                  ) : (
                    <>
                      {props?.taskData?.status === "closed" ? null : (
                        <Tooltip title="Edit">
                          <IconButton
                            sx={{
                              width: "35px",
                              height: "35px",
                              backgroundColor: "#fff",
                              boxShadow: "0 0 7px -2px #000",
                              "&:hover": {
                                backgroundColor: "#fff"
                              }
                            }}
                            onClick={() => setShowEdit(true)}
                          >
                            <EditIcon sx={{ color: !isRtl ? "#fff" : "#000" }} />
                          </IconButton>
                        </Tooltip>
                      )}
                      <Tooltip title="Assign users">
                        <IconButton
                          sx={{
                            width: "35px",
                            height: "35px",
                            backgroundColor: "#fff",
                            boxShadow: "0 0 7px -2px #000",
                            "&:hover": {
                              backgroundColor: "#fff"
                            }
                          }}
                          onClick={() => setShowAssing(true)}
                        >
                          <GroupsIcon sx={{ color: !isRtl ? "#fff" : "#000" }} />
                        </IconButton>
                      </Tooltip>
                    </>
                  )}
                  {props.status === "rejected" && JSON.parse(localStorage.getItem("roles")).includes(7) ? (
                    <Tooltip title="Delete Task">
                      <IconButton
                        sx={{
                          width: "35px",
                          height: "35px",
                          backgroundColor: "#fff",
                          boxShadow: "0 0 7px -2px #000",
                          "&:hover": {
                            backgroundColor: "#fff"
                          }
                        }}
                        onClick={() => {
                          if (window.confirm("Delete the Task?")) {
                            Delete(props?.id);
                          }
                        }}
                      >
                        <DeleteIcon sx={{ color: !isRtl ? "#fff" : "#000" }} />
                      </IconButton>
                    </Tooltip>
                  ) : null}
                  <Tooltip title="Attache File">
                    <IconButton
                      sx={{
                        width: "35px",
                        height: "35px",
                        backgroundColor: "#fff",
                        boxShadow: "0 0 7px -2px #000",
                        "&:hover": {
                          backgroundColor: "#fff"
                        }
                      }}
                      onClick={() => setShowAttachFile(true)}
                    >
                      <AttachmentIcon sx={{ color: !isRtl ? "#fff" : "#000" }} />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Log">
                    <IconButton
                      sx={{
                        width: "35px",
                        height: "35px",
                        backgroundColor: "#fff",
                        boxShadow: "0 0 7px -2px #000",
                        "&:hover": {
                          backgroundColor: "#fff"
                        }
                      }}
                      onClick={() => setShowLogForm(true)}
                    >
                      <RiIcons.RiFileList3Line style={{ color: !isRtl ? "#fff" : "#000" }} />
                    </IconButton>
                  </Tooltip>
                  {props?.task_type_id == 9 || props?.task_type_id == 15 ? (
                    <Tooltip title="Create Installation Task">
                      <IconButton
                        sx={{
                          width: "35px",
                          height: "35px",
                          backgroundColor: "#fff",
                          boxShadow: "0 0 7px -2px #000",
                          "&:hover": {
                            backgroundColor: "#fff"
                          }
                        }}
                        onClick={() => getEditTaskDataFromAPI(props?.TaskId, true)}
                      >
                        <CreateNewFolderIcon sx={{ color: !isRtl ? "#fff" : "#000" }} />
                      </IconButton>
                    </Tooltip>
                  ) : null}
                  {props?.is_mission_task == 1 ? (
                    <Tooltip title="Create Mission">
                      <IconButton
                        sx={{
                          width: "35px",
                          height: "35px",
                          backgroundColor: "#fff",
                          boxShadow: "0 0 7px -2px #000",
                          "&:hover": {
                            backgroundColor: "#fff"
                          }
                        }}
                        onClick={() => {
                          getEditTaskDataFromForMissionAPI(props?.TaskId);
                        }}
                      >
                        <AiIcons.AiFillFileAdd style={{ color: !isRtl ? "#fff" : "#000" }} />
                      </IconButton>
                    </Tooltip>
                  ) : null}
                  <Tooltip title="Show all related missions">
                    <IconButton
                      sx={{
                        width: "35px",
                        height: "35px",
                        backgroundColor: "#fff",
                        boxShadow: "0 0 7px -2px #000",
                        "&:hover": {
                          backgroundColor: "#fff"
                        }
                      }}
                      onClick={() => setShowAllMissions(true)}
                    >
                      <ImIcons.ImTree style={{ color: !isRtl ? "#fff" : "#000" }} />
                    </IconButton>
                  </Tooltip>
                </Box>
              </Box>
            </Box>
          )}
        </Box>

        {props?.task_type_id === 18 ? (
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center"
            }}
          >
            {skeletonLoading ? (
              <Skeleton
                animation="wave"
                sx={{
                  width: "90%",
                  height: "fit-content",
                  minHeight: "200px",
                  backgroundColor: "#f2f2f2",
                  boxShadow: "0 2px 7px -2px #626262  !important",
                  position: "relative",
                  zIndex: "99",
                  marginTop: "25px",
                  borderRadius: "5px",
                  webkitTransform: "scale(1) !important",
                  transform: "scale(1) !important"
                }}
              />
            ) : (
              <Box
                sx={{
                  width: "90%",
                  height: "fit-content",
                  minHeight: "200px",
                  backgroundColor: "#fff",
                  boxShadow: "0 2px 7px -2px #626262 ",
                  position: "relative",
                  marginTop: "25px",
                  zIndex: "99",
                  borderRadius: "5px"
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    padding: "15px 20px 0 20px"
                  }}
                >
                  {skeletonLoading ? (
                    <Skeleton
                      animation="wave"
                      sx={{
                        webkitTransform: "scale(1) !important",
                        transform: "scale(1) !important"
                      }}
                      width={300}
                      height={30}
                    />
                  ) : (
                    <Box
                      sx={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center"
                      }}
                    >
                      <Box>
                        <p style={{ fontSize: "25px", color: "#000" }}>مهمة نقل وحدات</p>
                        <p
                          style={{
                            height: "2.5px",
                            width: "100px",
                            backgroundColor: "#D46A43",
                            borderRadius: "5px",
                            position: "relative",
                            top: "-10px"
                          }}
                        ></p>
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "flex-end"
                        }}
                      >
                        <p style={{ fontSize: "25px", color: "#000" }}>الوحدات المنقولة</p>
                        <p
                          style={{
                            height: "2.5px",
                            width: "100px",
                            backgroundColor: "#D46A43",
                            borderRadius: "5px",
                            position: "relative",
                            top: "-10px"
                          }}
                        ></p>
                      </Box>
                    </Box>
                  )}
                </Box>
                <Box
                  sx={{
                    width: "100%",
                    padding: "30px 20px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                  }}
                >
                  <VehiclesList2 list={props?.taskData?.task_units_transfer} />
                </Box>
              </Box>
            )}
          </Box>
        ) : null}
        {props?.task_type_id === 17 ? (
          <>
            {/*==============================================
            ===============fourth Section here=============
            ============================================== */}
            <Box
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              {skeletonLoading ? (
                <Skeleton
                  animation="wave"
                  sx={{
                    width: "90%",
                    height: "fit-content",
                    minHeight: "200px",
                    backgroundColor: "#f2f2f2",
                    boxShadow: "0 2px 7px -2px #626262  !important",
                    position: "relative",
                    zIndex: "99",
                    marginTop: "25px",
                    borderRadius: "5px",
                    webkitTransform: "scale(1) !important",
                    transform: "scale(1) !important"
                  }}
                />
              ) : (
                <Box
                  sx={{
                    width: "90%",
                    height: "fit-content",
                    minHeight: "200px",
                    backgroundColor: "#fff",
                    boxShadow: "0 2px 7px -2px #626262 ",
                    position: "relative",
                    marginTop: "25px",
                    zIndex: "99",
                    borderRadius: "5px"
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      padding: "15px 20px 0 20px"
                    }}
                  >
                    {skeletonLoading ? (
                      <Skeleton
                        animation="wave"
                        sx={{
                          webkitTransform: "scale(1) !important",
                          transform: "scale(1) !important"
                        }}
                        width={300}
                        height={30}
                      />
                    ) : (
                      <Box
                        sx={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center"
                        }}
                      >
                        <Box>
                          <p style={{ fontSize: "25px", color: "#000" }}>Task Details</p>
                          <p
                            style={{
                              height: "2.5px",
                              width: "100px",
                              backgroundColor: "#D46A43",
                              borderRadius: "5px",
                              position: "relative",
                              top: "-10px"
                            }}
                          ></p>
                        </Box>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-end"
                          }}
                        >
                          <p style={{ fontSize: "25px", color: "#000" }}>تفاصيل الحسابات</p>
                          <p
                            style={{
                              height: "2.5px",
                              width: "100px",
                              backgroundColor: "#D46A43",
                              borderRadius: "5px",
                              position: "relative",
                              top: "-10px"
                            }}
                          ></p>
                        </Box>
                      </Box>
                    )}
                  </Box>
                  <Box
                    sx={{
                      width: "100%",
                      padding: "30px 20px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      flexDirection: "column"
                    }}
                  >
                    <DetailsList exportFunction={handleExportData} list={props?.task_details} />
                    <p
                      style={{
                        height: "2.5px",
                        width: "85%",
                        backgroundColor: "#d3d3d3",
                        borderRadius: "10px",
                        marginTop: "15px",
                        marginBottom: "15px"
                      }}
                    ></p>
                    {/* <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-end",
                      }}
                    >
                      <p style={{ fontSize: "25px", color: "#000" }}>
                        تفاصيل الوحدات
                      </p>
                      <p
                        style={{
                          height: "2.5px",
                          width: "100px",
                          backgroundColor: "#D46A43",
                          borderRadius: "5px",
                          position: "relative",
                          top: "-10px",
                        }}
                      ></p>
                    </Box> */}
                    <VehiclesList list={customersUnits} />
                  </Box>
                </Box>
              )}
            </Box>
            {/*==============================================
       ===============fifth Section here=============
       ============================================== */}
            <Box
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              {skeletonLoading ? (
                <Skeleton
                  animation="wave"
                  sx={{
                    width: "90%",
                    height: "fit-content",
                    minHeight: "200px",
                    backgroundColor: "#f2f2f2",
                    boxShadow: "0 2px 7px -2px #626262  !important",
                    position: "relative",
                    zIndex: "99",
                    marginTop: "25px",
                    borderRadius: "5px",
                    webkitTransform: "scale(1) !important",
                    transform: "scale(1) !important"
                  }}
                />
              ) : (
                <Box
                  sx={{
                    width: "90%",
                    height: "fit-content",
                    minHeight: "200px",
                    bgcolor: "#ffe6eb",
                    boxShadow: "0 2px 7px -2px #626262 ",
                    position: "relative",
                    marginTop: "25px",
                    zIndex: "99",
                    borderRadius: "5px"
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      padding: "15px 20px 0 20px"
                    }}
                  >
                    {skeletonLoading ? (
                      <Skeleton
                        animation="wave"
                        sx={{
                          webkitTransform: "scale(1) !important",
                          transform: "scale(1) !important"
                        }}
                        width={300}
                        height={30}
                      />
                    ) : (
                      <Box
                        sx={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center"
                        }}
                      >
                        <Box>
                          <p style={{ fontSize: "25px", color: "#000" }}>Task Finances</p>
                          <p
                            style={{
                              height: "2.5px",
                              width: "100px",
                              backgroundColor: "#D46A43",
                              borderRadius: "5px",
                              position: "relative",
                              top: "-10px"
                            }}
                          ></p>
                        </Box>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-end"
                          }}
                        >
                          <p style={{ fontSize: "25px", color: "#000" }}>المبالغ المستلمة</p>
                          <p
                            style={{
                              height: "2.5px",
                              width: "100px",
                              backgroundColor: "#D46A43",
                              borderRadius: "5px",
                              position: "relative",
                              top: "-10px"
                            }}
                          ></p>
                        </Box>
                      </Box>
                    )}
                  </Box>
                  <Box
                    sx={{
                      width: "100%",
                      padding: "30px 20px",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center"
                    }}
                  >
                    <FinancesList list={props?.task_finances} />
                  </Box>
                </Box>
              )}
            </Box>
          </>
        ) : null}
        {/*==============================================
       ===============sixth Section here=============
       ============================================== */}
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          }}
        >
          {skeletonLoading ? (
            <Skeleton
              animation="wave"
              sx={{
                width: "90%",
                height: "fit-content",
                minHeight: "300px",
                backgroundColor: "#f2f2f2",
                boxShadow: "0 2px 7px -2px #626262  !important",
                position: "relative",
                zIndex: "99",
                marginTop: "25px",
                borderRadius: "5px",
                webkitTransform: "scale(1) !important",
                transform: "scale(1) !important"
              }}
            />
          ) : (
            <Box
              sx={{
                width: "90%",
                height: "fit-content",
                minHeight: "300px",
                backgroundColor: "#fff",
                boxShadow: "0 2px 7px -2px #626262 ",
                position: "relative",
                marginTop: "25px",
                zIndex: "99",
                borderRadius: "5px"
                // paddingBottom:'20px'
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  padding: "15px 20px 0 20px"
                }}
              >
                {skeletonLoading ? (
                  <Skeleton
                    animation="wave"
                    sx={{
                      webkitTransform: "scale(1) !important",
                      transform: "scale(1) !important"
                    }}
                    width={300}
                    height={30}
                  />
                ) : (
                  <>
                    <p style={{ fontSize: "25px", color: "#000" }}>Task Social</p>
                    <p
                      style={{
                        height: "2.5px",
                        width: "100px",
                        backgroundColor: "#D46A43",
                        borderRadius: "5px",
                        position: "relative",
                        top: "-10px"
                      }}
                    ></p>
                  </>
                )}
              </Box>
              <Box
                sx={{
                  width: "100%",
                  height: "fit-content",
                  minHeight: "400px",
                  display: "flex",
                  alignItems: "flex-start"
                }}
              >
                <Box
                  sx={{
                    width: "15%"
                  }}
                >
                  <Box
                    sx={{
                      backgroundColor: !commentOrWorkLog ? "#f3f3f3" : "#bdb7b7",
                      borderLeft: !commentOrWorkLog ? "5px solid #1e6a99" : "none",
                      height: "60px",
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      cursor: "pointer"
                    }}
                    onClick={() => {
                      setCommentOrWorkLog(false);
                    }}
                  >
                    <span style={{ color: commentOrWorkLog ? "#fff" : "#000" }}>
                      Comments{" "}
                      <span
                        style={{
                          width: "30px",
                          height: "30px",
                          backgroundColor: "#1e6a99",
                          textAlign: "center",
                          color: "#fff",
                          margin: "0 5px",
                          padding: "0 5px",
                          borderRadius: "50%",
                          fontSize: "14px"
                        }}
                      >
                        {props.comments_count}
                      </span>
                    </span>
                  </Box>
                  <Box
                    sx={{
                      backgroundColor: commentOrWorkLog ? "#f3f3f3" : "#bdb7b7",
                      borderLeft: commentOrWorkLog ? "5px solid #1e6a99" : "none",
                      height: "60px",
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      cursor: "pointer"
                    }}
                    onClick={() => {
                      setCommentOrWorkLog(true);
                    }}
                  >
                    <span style={{ color: !commentOrWorkLog ? "#fff" : "#000" }}>Worklog</span>
                  </Box>
                </Box>
                <Box
                  sx={{
                    width: "85%",
                    height: "100%",
                    backgroundColor: "#f3f3f3"
                  }}
                >
                  {commentOrWorkLog ? <WorkLogs id={props.id} onRefTask={props} workLog={props.comment} workLogs_count={props.comments_count} workLogHeight={324} cardColor="#f3f3f3" /> : <Comments id={props.id} onRefTask={props} comment={props.comment} comments_count={props.comments_count} commentHeight={324} cardColor="#f3f3f3" />}
                </Box>
              </Box>
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
}
